import { c as _c } from "react/compiler-runtime";
import type { OpeningHours } from '@data-access/graphql/schema.types';
import { TZDate } from '@date-fns/tz';
import { formatWeekday } from '@utils/utils-format';
import { DEFAULT_TIME_ZONE } from '@/lib/time-zone';
type BeachChairOpeningHoursProps = {
  openingHours?: OpeningHours[];
};
export function BeachChairOpeningHours(t0) {
  const $ = _c(4);
  const {
    openingHours
  } = t0;
  if (!openingHours || openingHours.length === 0) {
    return;
  }
  let t1;
  if ($[0] !== openingHours) {
    t1 = openingHours.map(_temp);
    $[0] = openingHours;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <table className="font-body-copy"><tbody>{t1}</tbody></table>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
function _temp(hour) {
  return <tr key={hour.weekday}><td className="py-1">{formatWeekday(getWeekdayAsDate(hour.weekday))}</td><td className="text-end">{`${hour.opening} – ${hour.closing} Uhr`}</td></tr>;
}
const getWeekdayAsDate = (weekday: number) => new TZDate(2024, 0, 1 + weekday, DEFAULT_TIME_ZONE);